const OrderItem = ({label, count, isHighlight, onHandleClick}) => {
    const displayCount = isNaN(count) ? '0' : count.toString();
    return (
        <div className="flex justify-between items-center border-b border-dashed pb-2">
            <div className="flex items-center cursor-pointer" onClick={onHandleClick}>
                <span className="text-gray-700">{label}</span>
                {isHighlight && <span className="ml-1 mb-2 w-2 h-2 bg-red/70 rounded-full"></span>}
            </div>
            <span className="text-gray-600">{displayCount}</span>
        </div>
    )
};
export default OrderItem;